import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class QuizAttemptManager extends Model {
    static entity = 'quiz_attempt_manager';

    static fields() {
        return {
            id: this.attr(null),
            activity_id: this.attr(null),
            course_id: this.attr(null),
            user_id: this.attr(null),
            course_key_id: this.attr(null),
            online: this.attr(null),
            enrollment_groups: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
            attempt: this.attr(null),
            attempt_authorizations: this.attr(null),
        };
    }

    get has_active_status() {
        return ['attempt-started', 'in-review', 'in-waiting-room-post'].includes(this.attempt.status);
    }

    get current_attempt() {
        return this.attempt.history.find(attempt => attempt.id === this.user.quiz_active_id);
    }

    get total_added_time() {
        return this.attempt.status_history
            .filter(status => status.name === 'added-time')
            .reduce((acc, status) => acc + Number(status.reason), 0);
    }

    get has_been_in_review() {
        return this.attempt.status_history.some(status => status.name === 'in-review');
    }

    static async addTimeToBulkAttempts({ time, reason, enrollments, courseId }) {
        const queryBuilder = new QueryBuilder('quiz-attempt/add-time-bulk');
        const quizAttemptIds = enrollments.map(enrollment => enrollment.user.quiz_active_id);

        await this.api().post(
            queryBuilder.toUrl(),
            { time, reason, quiz_attempt_ids: quizAttemptIds, course_id: courseId },
            { save: false }
        );
    }

    static async addTimeToSingleQuizAttempt({ time, reason, enrollment, courseId }) {
        const quizAttemptId = enrollment.user.quiz_active_id;
        const queryBuilder = new QueryBuilder(`quiz-attempt/${quizAttemptId}/add-time`);

        await this.api().post(
            queryBuilder.toUrl(),
            { time, reason, course_id: courseId, user_id: enrollment.user.id },
            { save: false }
        );
    }
}
